'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../../external/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../../external/classnames/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["className", "children", "toggle", "tag", "closeAriaLabel", "titleClass"];

var ModalHeader = function ModalHeader(props) {
  var closeButton;
  var className = props.className,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      closeAriaLabel = props.closeAriaLabel,
      titleClass = props.titleClass,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var classes = index['default']('modal-header', className);
  var titleClasses = index['default']('modal-title', titleClass);

  if (toggle) {
    closeButton = /*#__PURE__*/React__default['default'].createElement("button", {
      type: "button",
      onClick: toggle,
      className: "close",
      "aria-label": closeAriaLabel
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      "aria-hidden": "true"
    }, String.fromCharCode(215)));
  }

  return /*#__PURE__*/React__default['default'].createElement("div", _extends['default']({
    "data-test": "modal-header"
  }, attributes, {
    className: classes
  }), /*#__PURE__*/React__default['default'].createElement(Tag, {
    className: titleClasses
  }, children), closeButton);
};

ModalHeader.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  closeAriaLabel: PropTypes__default['default'].string,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string]),
  toggle: PropTypes__default['default'].func
};
ModalHeader.defaultProps = {
  tag: 'h4',
  closeAriaLabel: 'Close'
};
exports.ModalHeader = ModalHeader;
exports['default'] = ModalHeader;